export default __webpack_public_path__ + "static/media/changePasswordSuccess.fbf427d7.svg";